import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Icon from '@material-ui/core/Icon';
//import { configure, setAddon } from '@storybook/react';
import { BreadcrumbPage } from "../../shared";
import CheckIcon from '@material-ui/icons/Check';

function Help(props) {
  const BreadcrumbList = [{ name: "Help", url: "" }];

  return (
    <div>

      <Box pt={0} mx={3} display="dlock">
        <BreadcrumbPage rows={BreadcrumbList} />
      </Box>

      <Grid container fluid="md" className="Help-page">

        {/* <Grid item xs={12} sm={12} md={6} lg={4} >

                <ul>
                    <li>
                        <a>Login</a>
                    </li>
                    <li>
                        <a>Home </a>
                    </li>
                    <li>
                        <a>Dashboard</a>
                    </li>
                    <li>
                        <a>Contracts</a>
                    </li>
                    <li>
                        <a>Assets</a>
                    </li>
                    <li>
                        <a>Ship Details</a>
                    </li>
                    <li>
                        <a>Transformers Details</a>
                    </li>
                    <li>
                        <a>Scheduler</a>
                    </li>
                    <li>
                        <a>Order a Kit</a>
                    </li>
                    <li>
                        <a>Samplogic</a>
                    </li>
                    <li>
                        <a>Reports</a>
                    </li>
                    <li>
                        <a>Trends</a>
                    </li>
                    <li>
                        <a>Alerts</a>
                    </li>
                    <li>
                        <a>Account</a>
                    </li>
                    <li>
                        <a>Admin</a>
                    </li>
                    <li>
                        <a>Logout</a>
                    </li>
                    
                </ul>



            </Grid> */}

        {/* <Grid item xs={12} sm={12} md={6} lg={8} > */}
        <Box className="help-text">
          <div className="help-Login">

            <h2>Login to Customer Portal</h2>
            <p>Any customer who wishes to access the VPS client portal must enter the login page and key in the desired user ID and password. This page includes the User ID, Password, Forget Password and New User Registration options.</p>
            <h4>Sign in - New User Customer Portal</h4>
            <p>At the VPS Customer Portal Login Page, user type to create valid credentials – User ID & Password.
              Previously existing customer or newly registered customers are eligible to login in desired fields.
            </p>
            <h4>Registering with us – Register Form</h4>
            <p>In order to register with us, locate & click at ‘Register’ here hyperlink option at the bottom right corner in the VPS Customer Portal credential form. </p>
            <p>Enter user first name respectively in requested fields – User to key in using either Upper case or lower case as per choice.</p>
            <p>Enter user Last name respectively in requested fields – User to key in using either Upper case or lower case as per choice.</p>
            <p>User to provide a valid E-mail address in its allotted field below.</p>
            <p>Once information for all respected fields has been entered, click on ‘Register’ CTA to receive a confirmation email upon registration. </p>
            <p><strong>Note:</strong> Upon Verification, authorization of unique customer id deemed by super user/ admin. In case of malfeasance, entity will deny access to indulging specimens. </p>
          </div>

          <div className="helo-home">
            <h2>Home Page</h2>
            <p>This page displays the basic information about the logged in user profile name, role, and company (could be like Ships, Transformers or Equipments). The image slides on the right side of the page loads the appropriate image related to the type of assets the logged in user belongs to.</p>
          </div>

          <div className="help-dashboard">
            <h2>Dashboard</h2>
            <p>Dashboard page displays the snippet details of Sample Status and Report status for last 30 days. The first half section displays the Samples statistics on the fuel, lube and VPS Power. The bottom section of the dashboard shows the Report statistics on the sampled items .To drill down more information on the sample and report status user can either clicking the Sample/Report status main section or by clicking on the individual test labels appearing on the right side of this page. Based on the Assets availability for the customer, the tab values for Fuel Analysis, Lube Analysis and VPS Power will be displayed. In case of not information of any asset, for instance Ship and Lube is not available, and then Fuel Analysis will be displayed. Report section will function the same way as mentioned above.</p>
          </div>

          <div className="help-contract">
            <h2>Contracts</h2>
            <p>This page contains the customer contract name, contract number and contract period.</p>
            <h4>Contracts Information </h4>
            <p>Customer: Under Filters form, enter customer full name in respected ‘Customer’ field box.</p>
            <p>Contract: Individually allotted contract number to each customer must entered in respected ‘Contract’ fields.</p>
            <p>Contract date: Contract registers date details such “as on” or “current date” details to be specifically mentioned in the allotted field option. </p>
            <p>Status: The following option displays the “Active” or “Inactive” status report of contract. </p>
            <p>Contracts Information – Supporting Data can be viewed clicking on the down trail icon in order to view other parameter data. Following it is the pre-existing details of customer contract, contract number, contract duration & status details of customer, Sales Agreement Lines reflect to items information.</p>
          </div>
          <div className="help-assets">
            <h2>Assets</h2>
            <p>This forum displays the Transformers and Ship details wherein the customer and contract details are reflected for users to track Asset storage information.</p>
          </div>
          <div className="help-ship">
            <h2>Ship Details</h2>
            <p> This page consist of the below information</p>
            <p>Filter Section: the field in this section allows the user to search the desired ship by keying in the Vessel name, Make, Model, Year built etc. The entered data in the filter section will load the ship details once the apply filter button is clicked.</p>
            <p>Ship List: This section has the list of Ships and the company it belongs to. In case of no ship assets for a selected company on the applied filters, then No data will be displayed in this section.</p>
            <p>Ship Details: Based on the selected ship in the ship list the complete details of the particular ship will be displayed in this section.</p>
            <p>View Equipments: Once this button is clicked, detailed information related to the equipments in the ship will be listed out. </p>
            <p>Contract and contact details of the ship is available at the bottom section of this page, were the user can get information on Contact person, designation, email, phone number and location  is listed. Similarly for Contract information the details like Service, contract number, Sales person, Contact customer and the status of the contract are listed.</p>

          </div>
          <div className="help-trans">
            <h2>Transformers Details</h2>
            <p>This page consist of the below information</p>
            <p>Filter Section: the field in this section allows the user to search the desired Transformers by keying in the Serial number, unit description, Voltage etc. The entered data in the filter section will load the Transformer details once the apply filter button is clicked.</p>
            <p>Transformer List: This section has the list of Transformers, Unit description and location it belongs to. In case of no Transformer asset for the selected company on the applied filters, then no data will be displayed in this section.</p>
            <p>Transformer Details: Based on the selected Transformer in the Transformer list the complete details of the particular asset will be displayed in this section.</p>
            <p>View Equipments: Once this button is clicked, detailed information related to the equipments in the ship will be listed out. </p>
            <p>Contract and contact details of the Transformer is available at the bottom section of this page, were the user can get information on Contact person, designation, email, phone number and location  is listed. Similarly for Contract information the details like Service, contract number, Sales person, Contact customer and the status of the contract are listed.</p>
          </div>
          <div className="help-shedul">
            <h2>Scheduler </h2>
            <p>Scheduler page provides the information about the sampling schedules that are aligned for the testing. This page will provide you the details of customer contract details and the due dates for any upcoming and flagging schedules. A filter section helps the user to search on any specific asset by keying in the Vessel name, year built, Make and Model. Further to this user can search the assets based on due dates and check for the status. The flag column in this page works on the logic mentioned below.</p>
            <p>When the user checks the Scheduler on a particular day say today, then </p>
            <ul>
              <li> Asset flagging shows Green, if the Next sampling date is more than 15 Days in the Calendar Schedule. Flag label is Good.</li>
              <li> Asset flagging shows Amber, when the Next sampling date is today or less than 15 days in the schedule calendar. Flag label is Due Soon.</li>
              <li> Assets flagging shows Red, if the Sampling day had crossed the due date and overdue will be shown. Flag label is Overdue.</li>
            </ul>
          </div>

          <div className="help-order">
            <h2>Order a Kit</h2>
            <p>Clients can use this menu option to place order for sampling kits. Based on the sample testing requirement the kits can be selected by the client. Below are some of the lists of kits displayed on the screen.</p>
            <ul>
              <li>  	Fuel Quality Test Sampling kit</li>
              <li>  	Power Plant sampling kit</li>
              <li> 	Oil Condition Monitoring Kit</li>
            </ul>
            <p>Recipient and Billing details can be seen on the right hand portion on this page. The information displayed here is about the Asset/Vessel name, IMO, Requestor etc.

            </p>

          </div>

          <div className="help-samplogic">
            <h2>Samplogic </h2>
            <p>This menu provides the complete logistic and tracking information on how the sample is picked up from the client and also tracing them for the sampling process. A separate user guide and FAQs is available within this page to explore more. Clients can create a pickup request here for sampling their Fuel/lubes and also the tracking can be done by keying in Trace code, Airway bill, Order ID and click on Search booking.</p>

          </div>
          <div className="help-reports">
            <h2>Reports</h2>
            <p>The report menu page displays the summary of total number of Sample report status with the status criteria as Critical, Warning, Satisfactory and Other. The right side section on the reports shows the list of test result charts. And these charts are the derived results for the various test report samples. For Fuel Analysis, the charts will be FQT, FSC, FCA, GC, and BQS. For Lube Analysis it will be displayed as OCM, SDA, Grease, Compatibility and Ferrography. And for Trans Oil Analysis the charts will be displayed as Routine (R), DGA +R, PCD, Furans. The filter section on the top of this page helps the user to search the desired Asset and load the report status for the same.</p>
            <p>A drill down option in this page will further load the details on sample type, Report description, service type, Report date and the Status flag as Warning, Critical and Satisfactory. By clicking on the icons below the drilldown button, reports can be either downloaded to a file or emailed.</p>
          </div>

          <div className="help-trends">
            <h2>Trends</h2>
            <p>Trends page shows the graphical representation on sampled report analysis between assets. The parameters displayed are derived from the sampled testing elements like water, acidity, Hydrogen, Methane etc. Based on the type of equipment selected, the Trends chart will be displayed. By using the filter option, user can select the required asset type and view the trends on the sampled analysis. Similarly the trends report can be downloaded to a file as data. The Trends chart is available for Transformers and Ships. By selecting the asset from the asset list, the trends chart will be displayed for those particular Equipments.</p>
          </div>

          <div className="help-alert">
            <h2>Alerts</h2>
            <p>Veritas Petroleum Services continuously monitors global fuel quality and fuel oil trends in various ports around the world. In the course of their monitoring, VPS issue VPS Bunker Alerts highlighting potentially problematic fuels in a given location. This Page will list down the number of Bunker alerts published by VPS. By using the filter section, user can search for a specific bunker alert in the system.</p>

          </div>
          <div className="help-account">
            <h2>Account</h2>
            <p>This page shows the logged in user account  information, the contracts he is assigned to and Account settings details like Name, email, profile picture, Designation, Phone number. User can use these filed for any amendments and save it. Likewise he can reset his password in this page. </p>


          </div>
          <div className="help-admin">

            <h2>Admin</h2>
            <p>Admin panel displays the list of Portal administrators in the system along with the list of other created users. The admin role entitlements in the customer portal functions as described below.</p>
            <h2>Super Admin</h2>


            <table className="box-shadow1 help-table">

              <thead>
                <tr>
                  <th>Control</th>
                  <th>Access</th>
                  <th>Functionality</th>
                  <th>Modification</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">

                  <td><CheckIcon /></td>
                  <td><CheckIcon /> </td>
                  <td><CheckIcon /> </td>
                  <td><CheckIcon /> </td>
                </tr>



              </tbody>

            </table>
            <p> The Elite user is eligible to manage/edit the access level of all users.</p>

            <h2>VPS Admin</h2>


            <table className="box-shadow1 help-table">

              <thead>
                <tr>
                  <th>Control</th>
                  <th>Access</th>
                  <th>Functionality</th>
                  <th>Modification</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">
                  <td> </td>
                  <td><CheckIcon /> </td>
                  <td><CheckIcon /> </td>
                  <td><CheckIcon /> </td>
                </tr>



              </tbody>

            </table>
            <p> Provider additional VPS Admins.</p>
            <p>Setup Client Admins and Client User in terms of Contracts
            </p>

            <h2>VPS User</h2>


            <table className="box-shadow1 help-table">

              <thead>
                <tr>
                  <th>Control</th>
                  <th>Access</th>
                  <th>Functionality</th>
                  <th>Modification</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">
                  <td><CheckIcon /> </td>
                  <td><CheckIcon /> </td>
                  <td><CheckIcon /> </td>
                  <td><CheckIcon /> </td>
                </tr>


              </tbody>

            </table>
            <p> Authoritative to and for pages with functionality and reports.</p>
            <p> Connects to multiple client sources.
            </p>

            <h2>Client Admin</h2>


            <table className="box-shadow1 help-table">

              <thead>
                <tr>
                  <th>Control</th>
                  <th>Access</th>
                  <th>Functionality</th>
                  <th>Modification</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">
                  <td> </td>
                  <td><CheckIcon /> </td>
                  <td><CheckIcon /> </td>
                  <td><CheckIcon />   </td>
                </tr>


              </tbody>

            </table>
            <p>	Member is eligible to create only ONE Admin for each client</p>
            <p>	Client Admin is capable to create client users</p>
            <p>	Limited functionality and access provision provided within company.  </p>

            <h2>Client User</h2>


            <table className="box-shadow1 help-table">

              <thead>
                <tr>
                  <th>Control</th>
                  <th>Access</th>
                  <th>Functionality</th>
                  <th>Modification</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">
                  <td><CheckIcon />  </td>
                  <td><CheckIcon /> </td>
                  <td><CheckIcon />  </td>
                  <td> <CheckIcon />  </td>
                </tr>


              </tbody>

            </table>

            <p> User accessibility based on client and contract</p>
            <p><b>User Creation: </b>There are two options available in the system to create new users</p>

            <ul><li> Any first time user can user the Register option in the login page to create his/her desired user name.  The user must enter the login name and the domain (Company) email id to create the user ID. Upon creating the ID, there will be two levels of authentication and approval done at the back end. Firstly the domain admin will assign the entitlements for the user and saves the changes. Secondly the user ID is approved at the super admin level in VPS.</li>
              <li> The Registered client admin can create a new user in the admin page by keying in the user name and entitlements, this process is done by clicking create new button. Once the creation is done, VPS admin will have to do the second level approval.</li>
            </ul>
            <p><b>User Data Access Hierarchy</b></p>
            <p>User Data Access will be hierarchy based with the following level</p>

            <ul>
              <li> 	Client Level Hierarchy
                <ul>
                  <li>Will have visibility on all Client Contracts, Assets and Services under them. Will not be able to create users</li>
                </ul>

              </li>
              <li> 	Contract Level Hierarchy
                <ul>
                  <li>Can be single or multiple contracts </li>
                  <li>Only the Assets and Services under the selected Contract will be visible</li>
                </ul>

              </li>
              <li> Asset Level Hierarchy
                <ul>
                  <li>Can be single or multiple Ships</li>
                  <li>Only the services under the selected Ships will be visible</li>
                </ul>
              </li>
              <li> Location Level</li>
              <li>Asset Name Level</li>
              <li>	Services Level Hierarchy</li>
              <li>	Equipment/Sampling Point Level</li>

            </ul>

            <p><b>New User Access Level Workflow</b></p>

            <ul>
              <li> Client Admin add/edit New User
                <ul>
                  <li> Selects Hierarchy level</li>
                  <li> 	If Selects Client Level. Click OK</li>
                  <li> If selects Contract Level
                    <ul>
                      <li>    	Display All contracts for the Client</li>
                      <li>  Client Admin can select the contracts that are associated with the user. One to many contracts can be selected. Click Ok</li>
                    </ul>

                  </li>
                  <li> 	If selects Asset Level
                    <ul>
                      <li>  Display All contracts for the Client</li>
                      <li> Display All Assets of selected contracts for the Client</li>
                      <li> Client Admin can select the Assets that are associated with the user. One to many Asset can be selected. Click Ok</li>
                    </ul>

                  </li>
                  <li> If selects Location Level

                    <ul>
                      <li> 	Display All contracts for the Client</li>
                      <li> 	Display All Assets of selected contracts for the Client</li>
                      <li>  	Display All Locations of selected Assets for the Client</li>
                      <li> 	Client Admin can select the Locations that are associated with the user. One to many Location can be selected. Click Ok</li>
                    </ul>

                  </li>
                  <li> 	If selects Asset Name Level

                    <ul>
                      <li> 	Display All contracts for the Client</li>
                      <li> Display All Assets of selected contracts for the Client</li>
                      <li> 	Display All Locations of selected Assets for the Client</li>
                      <li>  Client Admin can select the Locations that are associated with the user. One to many Location can be selected. Click Ok</li>
                    </ul>
                  </li>
                  <li> 	If Selects Service Level

                    <ul>
                      <li> Display All contracts for the client</li>
                      <li> Selecting the contracts will list all the ships in that contract</li>
                      <li> Selecting the ships will display all the services associated with those ships</li>
                      <li> 	Client Admin can then select the services that are associated with the user. One to many services can be selected. Click OK.</li>
                    </ul>
                  </li>
                  <li> If Selects Equipment Level
                    <ul>
                      <li>  Display All contracts for the client</li>
                      <li> Selecting the contracts will list all the ships in that contract</li>
                      <li>  Selecting the ships will display all the services associated with those ships</li>
                      <li> Client Admin can then select the services that are associated with the user. One to many services can be selected. Click OK.</li>
                    </ul>

                  </li>
                </ul>

              </li>

            </ul>

            <p><b>User Access at Screen Levels</b></p>
            <p>The following Roles will be defined in the system</p>
            <ul>
              <li>	Sampler</li>
              <li>Asset Manager (e.g. Captain, Chief Engineer)	</li>
              <li>Contract Managers (e.g. Superintendent)	</li>
              <li>Contract Administrator	</li>
              <li>Fleet Manager (Group of Assets)	</li>
              <li>	Company Manager (Fleet Director)</li>
              <li>High-level Management Executive</li>
              <li>CC Customer</li>
              <li>VPS/Client Admin</li>


            </ul>
            <p>Every User’s Access given to each user Functionality can be controlled by either the VPS Admin or the Client’s Admin.</p>
            <p>Client Admin can give access to their client users with Level equal or lower than what the Client Admin has been set to by the VPS Admin</p>



          </div>
          <div className="help-logout">
            <h2>Logout </h2>
            <p>By click on the logout menu, user will be logged out from the customer portal.</p>
          </div>

          {/* </Grid> */}

        </Box>

      </Grid>

    </div>
  )
}


export default Help


/* import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Icon from '@material-ui/core/Icon';


function Help(props) {
   return (
       <div>
           <Grid container fluid="md"  className="Help-page">
               <Grid item xs={12} >
               <Box className="help-text">
                   <h2>Login to Customer Portal </h2>
                   <p>Any customer who wishes to access the VPS client portal must enter
                   the login page and key in the desired user ID and password. This page
                   includes the User ID, Password, Forget Password and New User
                   Registration options.
                   </p>
                   <h4>Sign in - New User Customer Portal</h4>
                   <ul>
                       <li>At the VPS Customer Portal Login Page, user type to create valid
                       credentials – User ID and Password. </li>
                       <li>Previously existing customer or newly registered customers are
                       eligible to login in desired fields. </li>
                   </ul>
                   <h4>Registering with us – Register Form</h4>
                  <ul>
                   <li>In order to register with us, locate & click at ‘Register’ here
hyperlink option at the bottom right corner in the VPS Customer
Portal credential form. </li>
<li>Enter user first name respectively in requested fields – User to
key in using either Upper case or lower case as per choice.</li>
<li>Enter user Last name respectively in requested fields – User to
key in using either Upper case or lower case as per choice.</li>
<li>User to provide a valid E-mail address in its allotted field below.</li>
<li>Once information for all respected fields have been entered,
click on ‘Register’ CTA to receive a confirmation email upon
registration. </li>
</ul>
<div className="note-coopy">
<h4>Note</h4>
<p>UPON VERIFICATION, AUTHORIZATION OF UNIQUE CUSTOMER ID
DEEMED BY SUPER USER/ ADMIN. INCASE OF MALFEASENCE, ENTITY
WILL DENY ACCESS TO INDULGING SPECIMENS.</p>
</div>
<h2>Contracts – Customer Portal </h2>
<p>This page contains the customer contract name, contract number
and contract period.</p>
<h4>Contracts Information </h4>
<ul>
<li>Customer: Under Filters form, enter customer full name in
respected ‘Customer’ field box.</li>
<li>Contract: Individually allotted contract number to each customer
must entered in respected ‘Contract’ fields.
</li>
<li>Contract date: Contract register date details such “as on” or
“current date” details to be specifically mentioned in the
allotted field option. </li>
<li>Status: The following option displays the “Active” or “Inactive”
status report of contract. </li>

</ul>
<h4>Contracts Information – Supporting Data</h4>
<p>In such case, user to click on the down trail icon <ExpandMoreIcon className="icon-align" />

in order to
view other parameter data.</p>
<ul>
<li> Following it is the pre-existing details of customer contract,
contract number, contract duration & status details of
customer.</li>
<li>Sales Agreement Lines reflect to items information </li>

</ul>

<table className="box-shadow1 help-table">

<thead>
   <tr>
   <th>ITEM NO</th>
   <th>FQT_APS</th>
   <th>Specifiesunique code</th></tr>
</thead>
<tbody>
<tr>
<td>ITEM/CATEGORY</td>
<td>FUEL QUALITY TESTING- ADDITIONAL
PROTECTION SERVICES.</td>
<td>Unique
Item/Category
Name</td>
</tr>
<tr>
   <td>QUATITY</td>
   <td>250</td>
       <td>Units</td>
</tr>


</tbody>

   </table>
   <ul>
<li> Additional Test Parameters</li>
<li>Assets Under Contract</li>
<li>VPS Sales Person displays the vendor/ POC</li>
   </ul>



               </Box>

               </Grid>
               </Grid>
          
       </div>
   )
}


export default Help
*/

/* import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import { BreadcrumbPage } from "../../shared";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { getRequest, postRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { CommonCss } from "../../services/CommonCss";
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import axios from "axios";
import { cookieKeys, getCookie } from "../../services/Cookies";

import {
  FormHelperText,
  Input,
  Radio,
  InputLabel,
  InputBase,
} from "@material-ui/core";
const helpData = require("../../../data/help.json")
const TextInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);
const DateInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "90px",
    padding: "10px 10px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
const useStyles = makeStyles((theme) => ({
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 1px #e0e0e0",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  tableHeight: {
    height: "480px",
    overflowY: "auto",
    boxShadow: "0 0 0 #eee",
    backgroundColor: "transparent",
  },
  textCenter: {
    textAlign: "center",
  },
  tableCellBox: {
    borderTop: "2px solid #ff000000",
    borderBottom: "2px solid #ff000000",
  },
  iframeBox: {
    backgroundColor: "#5f5f5f",
  },
  active: {
    color: "#ff4717",
  },
  inActive: {
  },
}));

export default function Help() {
  const classes = useStyles();
  const BreadcrumbList = [{ name: "Help", url: "" }];
  const [openHlepPage, setOpenHlepPage] = useState(0);
  const openHlepBox = (index)=>{
    setOpenHlepPage(index);
  }
  return (
    <Box component="main" mx={3} className={classes.content + " rightbar"}>
      <Box pb={3} pt={0} display="dlock">
        <BreadcrumbPage rows={BreadcrumbList} />
      </Box>
      <Box pt={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={5}>
            <TableContainer component={Paper} className={classes.boxLayout}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                      <TableCell>
                          {
                              helpData.map((row, index)=>{
                                  return (
                                      <Box className={openHlepPage == index?classes.active:classes.inActive}>
                                          
                                                                         
                                          <Grid container  > */
{/* <Grid item xs={2}>
                                            <Box>{row.icon}</Box>
                                            </Grid> */}
{/* <Grid item xs={8} >
                                            <Box onClick={()=>{
                                                openHlepBox(index);
                                            }} ><h2 justifyContent="center">{row.name}</h2></Box>
                                            <Box>{row.content}</Box>
                                            </Grid>
                                        </Grid>                                      
                                      </Box>
                                      
                                  )
                              })
                          }
                      </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} sm={12} md={7}>
            <TableContainer component={Paper} className={classes.boxLayout}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                    <Grid container  >                           
                        <Grid item xs={12} >
                        <Box ><h2 justifyContent="center">{helpData[openHlepPage].name}</h2></Box>
                        <Box>{helpData[openHlepPage].content}</Box>
                        </Grid>
                    </Grid>  
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCellBox}>
                      <Box>
                        
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
  */}
